module.exports = __webpack_public_path__ + "files/bd6b7e2611997c3adee39dfde6fb29ff.png";